import { render } from "./porthole-avatar.vue?vue&type=template&id=f5afd53c&lang=pug"
import script from "./porthole-avatar.vue?vue&type=script&lang=js"
export * from "./porthole-avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__